import { daysDiff } from "util/date-helper";
import { getLSObject, setLSItem } from "util/localStorageUtils";
import yieldToMain from "util/lodash/yieldToMain";

export const cleanKlaviyoStorage = () => {
  // Remove klaviyo data from localstorage if it is older than 1 day bcz it exceeds localstorage limit
  // https://partsavatar.sentry.io/issues/6196656948/?project=1187556&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&statsPeriod=30d&stream_index=4
  yieldToMain().then(() => {
    const klaviyoIdentificationSync = getLSObject("kl-post-identification-sync");
    const klaviyoOldestTimestamp = klaviyoIdentificationSync?.[0]?.time;
    if (klaviyoOldestTimestamp) {
      const klaviyoDate = new Date(klaviyoOldestTimestamp);
      const klaviyoDays = daysDiff(klaviyoDate, new Date());
      const localStorageSize = getLocalStorageSize();
      // Delete klaviyo storage if it's more than 1 day or localstorage size >= 3MB
      if (klaviyoDays > 1 || localStorageSize >= 3) {
        setLSItem("kl-post-identification-sync", JSON.stringify([]));
      }
    }
  });
};

// Get localstorage size in MB
function getLocalStorageSize() {
  try {
    let total = 0;
    // eslint-disable-next-line no-restricted-syntax
    for (const key in localStorage) {
      // Check if it's an actual localStorage key
      if (localStorage.hasOwnProperty(key)) {
        // Safely get the item and calculate its size
        try {
          const value = localStorage.getItem(key);
          total += (key.length + (value ? value.length : 0)) * 2;
        } catch (e) {
          console.error(`Error processing key: ${key}`, e);
        }
      }
    }
    return Number((total / (1024 * 1024)).toFixed(2));
  } catch (error) {
    console.error("Error calculating localStorage size", error);
    return 0;
  }
}
